import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import HomeIcon from '@mui/icons-material/Home';

import { AppConfigContext } from '@providers/AppConfigProvider';

import Breadcrumb from '@/types/components/common/Breadcrumb';

type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[] | null;
};

export default function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
  const { isMobile } = useContext(AppConfigContext);
  return (
    <Box
      className={`${isMobile ? 'my-6 mx-5' : 'my-6 ml-24'} flex space-x-4 items-center`}
      role="presentation"
      sx={{
        overflowX: 'auto',
      }}
    >
      <MuiBreadcrumbs
        aria-label="breadcrumb"
        sx={{
          '& .MuiBreadcrumbs-ol': {
            whiteSpace: 'nowrap',
            flexWrap: 'nowrap',
          },
        }}
      >
        {breadcrumbs?.map((breadcrumb, index) => {
          if (index === breadcrumbs.length - 1) {
            return (
              <Typography key={breadcrumb.item} className="flex items-center text-sm text-[#808080] leading-[22px]">
                {breadcrumb.name}
              </Typography>
            );
          }

          return (
            <Link
              key={breadcrumb.item}
              className="flex items-center hover:underline text-sm decoration-[#191919] text-[#191919] rf-hover-text"
              href={breadcrumb.item}
            >
              {index === 0 && <HomeIcon className="mr-2" fontSize="inherit" />}
              {breadcrumb.name}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
}
